import script from "./BaseHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseHeader.vue?vue&type=script&setup=true&lang=js"

import "./BaseHeader.vue?vue&type=style&index=0&id=6136fe10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6136fe10"]])

export default __exports__